export default __webpack_public_path__ + "static/summer_containers8-2039d6c68a208a8da95718206114d683.webp";